import { configureStore, ActionType } from "bb-tab-selector";
import loadStore from "./storeLoader";

/**
 * Define the inbound and outbound messages to/from this components store
 *
 * @ignore
 * @type {{inbound: *[], outbound: *[]}}
 */

const config = {
  inbound: [
    ActionType.SWITCH_TAB,
    ActionType.UPDATE_MARKETS
  ],
  outbound: [
  ActionType.SWITCHED_TAB
  ]
};

/**
 * Create the TabBar redux store
 *
 * @ignore
 * @returns {*}
 */
const tabStore = () => loadStore(config, configureStore);

export default tabStore;



// WEBPACK FOOTER //
// ./src/stores/tabStore.js